export const numberOTP = 4;

export const timeResendOTPCode = 2 * 60 * 1000; // 2 minutes

export const pageDefault = 1;

export const pageSizeDefault = 10;

export const pageSizePossible = [10, 20, 30, 50];

export const pagingParamList = ['page', 'pageSize'];

export const dateFormat = 'DD MMM YYYY';
export const dateFormatISO = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export const dateTableFormat = 'ddd MMM DD YYYY';

export const dateFormatShort = 'D/M/YY';

export const timeFormat12 = 'h:mm a';

export const stringDateFormat = 'dddd, MMMM DD';

export const timeFormat = 'HH:mm';

export const defaultPhoneCountry = 'UA';

/** Main InfoTrac User */
export const infoTracUser = {
  userFullName: 'Carson Client',
  username: 'john_doe', // demo_carson_client
  email: 'carson@guidancefinancial.com',
  title: 'Guidance Financial Management',
  company: 'Guidance Financial Institution', // 'InfoIMAGE inc.',
  address: {
    name: '141 Jefferson Dr.',
    city: 'Menlo Park',
    state: 'ca',
    zip: '94025',
  },
  contactInformation: {
    website: 'www.infoimageinc.com',
    officePhone: '(650)473-6388',
    ext: '-',
    fax: '(650)473-6300',
    firstName: 'John',
    lastName: 'Doe',
    fullName: 'John Doe',
  },
  manageSettings: {
    roles: '',
    manageAlerts: '',
  },
  passwordPlaceholder: 'Carson12345!',
};

/** Main Guidance User */
export const guidanceUser = {
  userFullName: 'Carson Client',
  username: 'admin',
  email: 'carson@guidancefinancial.com',
  title: 'Guidance Financial Management',
  company: 'Guidance Financial Institution', // 'InfoIMAGE inc.',
  // address: {
  //   name: '141 Jefferson Dr.',
  //   city: 'Menlo Park',
  //   state: 'ca',
  //   zip: '94025',
  // },
  contactInformation: {
    officePhone: '(650)473-6388',
    // website: 'www.infoimageinc.com',
    // ext: '-',
    // fax: '(650)473-6300',
    // firstName: 'John',
    // lastName: 'Doe',
    // fullName: 'John Doe',
  },
  // manageSettings: {
  //   roles: '',
  //   manageAlerts: '',
  // },
  passwordPlaceholder: 'Guidance12345!',
};
